import { render, staticRenderFns } from "./ConsentFormsName.vue?vue&type=template&id=17512116&"
import script from "./ConsentFormsName.vue?vue&type=script&lang=js&"
export * from "./ConsentFormsName.vue?vue&type=script&lang=js&"
import style0 from "./ConsentFormsName.vue?vue&type=style&index=0&id=17512116&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports